var app = angular.module('leonardo');

var WPFormCheckbox = function(FilterService) {
  return {
    restrict: 'A',
    require: 'ngModel',
    transclude: true,
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      selectAll: '=',
      ngChange: '&',
      filter: '@',
      help: '=?'
    },
    templateUrl: 'views/templates/form/form-checkbox.html',
    link: function (scope, element, attrs, ngModelCtrl) {

      scope.getColorIcon = function() {
        if (scope.disabled) {
          return scope.value ? 'tertiaryColor' : '';
        }
        else {
          return scope.value ? 'secondaryColor' : 'white';
        }
      };

      scope.getHoverColor = function() {
        if (scope.disabled) {
          return scope.value ? 'tertiaryColor' : '';
        }
        else {
          return 'secondaryColor';
        }
      };

      scope.setValue = function(){
        if (scope.filter) {
          FilterService.setFilter(scope.filter, scope.value);
        }
        ngModelCtrl.$setViewValue(scope.value);
        ngModelCtrl.$render();
      };

      ngModelCtrl.$render = function() {
        scope.value = ngModelCtrl.$modelValue;
        if (!scope.value && scope.filter) {
          scope.value = FilterService.getFilter(scope.filter);
        }
        scope.iconColor = scope.getColorIcon();
        scope.iconHoverColor = scope.getHoverColor();
      };

      scope.selectAllCheckbox = function(value) {
        if (scope.disabled) {
          return;
        }
        var subgroup = scope.getSubgroup(scope);
        var field_data = scope.getFieldData(scope);
        angular.forEach(subgroup.fields, function(field){
          field_data[field.key] = value;
        });
      };

      scope.getSubgroup = function(scpe) {
        if (!scpe) {
          return;
        }
        if (scpe.subgroup) {
          return scpe.subgroup;
        }
        else {
          return scope.getSubgroup(scpe.$parent);
        }
      };

      scope.getFieldData = function(scpe) {
        if (!scpe) {
          return;
        }
        if (scpe.field_data) {
          return scpe.field_data;
        }
        else {
          return scope.getFieldData(scpe.$parent);
        }
      };

      element.click(function() {
        if (scope.disabled) {
          return;
        }
        if (scope.selectAll) {
          scope.selectAllCheckbox(!ngModelCtrl.$modelValue);
        }
        else {
          var subgroup = scope.getSubgroup(scope);
          if(subgroup) {
            var field_data = scope.getFieldData(scope);
            if (field_data) {
              angular.forEach(subgroup.fields, function(field){
                if (field.data.select_all) {
                  field_data[field.key] = false;
                }
              });
            }
          }
        }
        scope.value = !scope.value;
        scope.setValue();
        scope.ngChange();
      });

      scope.$watch('value', function (newValue, oldValue) {
        if (!isEquals(newValue, oldValue)) {
          scope.setValue(newValue);
          scope.iconColor = scope.getColorIcon();
          scope.iconHoverColor = scope.getHoverColor();
        }
      });

      scope.$on('filter-service:filter-changed', function($event, key, value) {
        if (scope.filter === key){
          if (scope.value !== value) {
            scope.value = value;
          }
        }
      });

      scope.$on('filter-service:filter-removed', function($event, key) {
        if (scope.filter === key) {
          if (scope.value) {
            scope.value = false;
          }
        }
      });

      scope.$watch('disabled', function(newValue, oldValue){
        if (!isEquals(newValue, oldValue)) {
          if (newValue) {
            element.addClass('disabled');
          }
          else {
            element.removeClass('disabled');
          }
          scope.iconColor = scope.getColorIcon();
          scope.iconHoverColor = scope.getHoverColor();
        }
      });

    }
  };
};

app.directive('wpFormCheckbox', ['FilterService', WPFormCheckbox]);
